import React from "react";
import { PhishNetLogo } from "@ui/components";
import { Container } from "../portalInstructions/styled"
import { MessageBar, MessageBarType } from "@fluentui/react";

export const Authorize = () => {
  if (!globalThis.location) {
    return <></>
  }
  const errors = Object.fromEntries(globalThis.location.hash.replace("#", "").split("&").map(v => v.split("=")))

  return (
    <Container>
      <PhishNetLogo />
      <div style={{ "maxWidth": "50vw" }}>
        {errors.error && <MessageBar messageBarType={MessageBarType.error}>{errors.error_description.replaceAll("+", " ")}</MessageBar>}
      </div>
    </Container>
  )
}
